import { render } from "./edit-supplier.vue?vue&type=template&id=aa65f842"
import script from "./edit-supplier.vue?vue&type=script&lang=js"
export * from "./edit-supplier.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__